import { router } from '@inertiajs/react';
import { useEffect, useState } from 'react';

import useTimeout from '../../hooks/useTimeout';
import postMessageToParent from '../helpers/postMessageToParent';
import useBookingFormProps from '../pages/BookingForm/hooks/useBookingFormProps';

type Options = {
    title?: string;
};

const usePostNavigationToParent = ({ title }: Options) => {
    const { analytics } = useBookingFormProps();

    const [history, setHistory] = useState<Array<string>>([]);
    const [currentUrl, setCurrentUrl] = useState<string>(() => {
        return window.location.pathname + window.location.search;
    });

    const postNavigateMessage = () => {
        if (!currentUrl) {
            return;
        }

        postMessageToParent({
            type: 'lb-navigate',
            title: title,
            path: currentUrl,
            previousPath: history[0] ?? '',
            analytics: analytics,
        });

        setHistory([currentUrl, ...history.slice(0, 1)]);
    };

    /**
     * Wait for the title to match the page URL
     */
    useTimeout(postNavigateMessage, 250, [currentUrl, title]);

    useEffect(() => {
        return router.on('navigate', (event) => {
            setCurrentUrl(event.detail.page.url);
        });
    }, []);
};

export default usePostNavigationToParent;
